







































import { computed, defineComponent, onMounted } from '@vue/composition-api';
import { PropType } from 'vue';
import { BudgetMode } from '@tt4b/ttam-enums';
import { BudgetModeOptionItem } from '../types';
import { CurrencyOption } from './../../../../hooks/creation/account/useCurrencyOption/index';
import { trackEvent } from './../../../../utils/index';
import { XInputNumber, XSpace } from '@okee-uikit/web-components-vue';
const name = 'ttam-budget-set';

export default defineComponent({
  name,
  components: {
    XInputNumber,
    XSpace,
  },
  props: {
    budget: {
      type: [String, Number],
      required: true,
    },
    budgetMode: {
      type: Number as PropType<BudgetMode>,
      required: true,
    },
    budgetModeOptions: {
      type: Array as PropType<BudgetModeOptionItem[]>,
      default: () => [],
      required: true,
    },
    currencyOption: {
      type: Object as PropType<CurrencyOption>,
      default: () => ({}),
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    budgetModeDisabled: {
      type: Boolean,
      default: false,
    },
    placeholder: { type: String, default: '' },
    prefill: {
      type: Boolean,
      default: false,
    },
    objectiveType: {
      default: '',
    },
    validateStatus: {
      type: String,
      default: 'default',
    },
  },
  setup(props, { emit }) {
    const _budget = computed({
      get: () => props.budget,
      set: v => emit('budget-change', v),
    });

    const _budgetMode = computed({
      get: () => props.budgetMode,
      set: v => {
        emit('budget-mode-change', v);
      },
    });
    onMounted(() => {
      if (props.currencyOption.precision === 0 && props.prefill) {
        emit('budget-change', props.budget);
      }
    });

    const onBlur = () => {
      const val = _budget.value;
      emit('budget-blur', val);
      trackEvent('create_budget_blur', {
        budget: Number(val) || 0,
        budgetMode: _budgetMode.value,
        currency: props.currencyOption?.currency,
        objective_type: props.objectiveType,
        action_level: 'adgroup',
      });
    };
    const onChange = v => {
      emit('budget-changed', v.detail);
    };
    return {
      name,
      _budget,
      _budgetMode,
      onBlur,
      onChange,
    };
  },
});
